import { Form, Text } from 'react-form';
import { AbconetApi } from '../General/AbconetApi';

export class PasswordReset extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaved: true,
            isSaving: false,
            success: false,
            message: "",
            passwordError: false,
            passwordErrorMessage: '',
            submittedValues: this.props.initialState,
            initialFormState: true
        }

        if (this.props.refreshPage !== null && this.props.refreshPage === true) {
            window.location.reload();
        }
    }

    sendGenerateTokenToServer() {
        var self = this;

        AbconetApi.post('/api/user/' + this.state.submittedValues.email + '/generatetoken').then(response => {
            if (response === true) {
                setTimeout(() => {
                    self.setState({
                        isSaved: true,
                        success: true,
                        message: "Success! Please check your email inbox regarding instructions on how to reset your password.",
                        isSaving: false,
                        initialFormState: false,
                    });
                }, 1000);
            }
        }).catch((error) => {
            this.setState({
                isSaved: true,
                success: false,
                isSaving: false,
                initialFormState: false,
            });
        });
    }

    submitGenerateToken(submittedValues) {
        this.setState({ submittedValues, message: '', isSaving: true }, this.sendGenerateTokenToServer);
    }

    sendPasswordResetToServer() {
        var self = this;

        var contactDto = {
            password: this.state.submittedValues.password
        };

        AbconetApi.post('/api/user/' + this.props.initialState.token + '/resetpassword', contactDto).then(response => {
            if (response === true) {
                setTimeout(() => {
                    self.setState({
                        isSaved: true,
                        success: true,
                        message: "Success! You may now login using your new password.",
                        isSaving: false,
                        initialFormState: false,
                    });
                }, 1000);
            } else {
                setTimeout(() => {
                    self.setState({
                        isSaved: true,
                        success: false,
                        message: "Error resetting of password, please contact us immediately on 1800 177 399.",
                        isSaving: false,
                        initialFormState: false,
                    });
                }, 1000);
            }
        });
    }

    submitPasswordReset(submittedValues) {
        if (submittedValues.password != submittedValues.confirmPassword) {
            this.setState({ passwordError: true, passwordErrorMessage: 'Password did not matched' });
            return;
        }

        if (submittedValues.password === '' && submittedValues.confirmPassword === '') {
            this.setState({ passwordError: true, passwordErrorMessage: 'Please enter a password' });
            return;
        }

        if (submittedValues.password.length <= 4) {
            this.setState({ passwordError: true, passwordErrorMessage: 'Password length must be five(5) characters or more.' });
            return;
        }

        this.setState({ submittedValues, message: '', passwordError:false, isSaving: true }, this.sendPasswordResetToServer);
    }

    renderSaveButton() {
        if (this.state.success === true) {
            return;
        }

        var btnText = 'Submit';
        var btnClass = 'changes';

        if (this.state.isSaved && this.state.initialFormState == false) {
            btnText = 'Submitted';
            btnClass = 'saved';
        }

        if (this.state.isSaving) {
            btnText = 'Submitting';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    setChange() {
        this.setState({ isSaved: false });
    }

    renderMessage() {
        if (this.state.message !== '' && this.state.success === true) {
            return <div className="alert alert-info">
                <h5> {this.state.message} </h5>
            </div>;
        } else if (this.state.message !== '' && this.state.success === false) {
            return <div className="alert alert-danger">
                <h5> {this.state.message} </h5>
            </div>;
        }
    }

    renderpasswordError() {
        if (this.state.passwordError === true) {
            return <div className="alert alert-danger">
                <h5> {this.state.passwordErrorMessage}</h5>
            </div>;
        }
    }

    renderGenerateTokenForm() {
        if (this.props.initialState.id === -1 && this.state.success === false) {
            return (
                <div className="row">
                    <div className="col-2"></div>
                    <div className="col-8">
                        <Form
                            onChange={this.setChange.bind(this)}
                            onSubmit={this.submitGenerateToken.bind(this)} defaultValues={this.state.submittedValues}>
                            {formApi => {
                                this.formApi = formApi;
                                return (
                                    <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                                        <div className="card card-body bg-light">
                                            <h5>
                                                <label htmlFor="email">Email Address:</label>
                                            </h5>
                                            <Text field="email" id="email" className="form-control" />
                                        </div>
                                        <div>
                                            <br />
                                            {this.renderSaveButton()}
                                        </div>
                                    </form>
                                )
                            }}
                        </Form>
                    </div>
                    <div className="col-2"></div>
                    <div>
                    </div>
                </div>
            );
        }
    }

    renderPasswordResetForm() {
        if (this.props.initialState.id === 0 && this.props.initialState.token !== '' && this.state.success === false) {
            return (
                <div className="row">
                    <div className="col-2"></div>
                    <div className="col-8">
                        {this.renderpasswordError()}
                        <Form
                            onChange={this.setChange.bind(this)}
                            onSubmit={this.submitPasswordReset.bind(this)} defaultValues={this.state.submittedValues}>
                            {formApi => {
                                this.formApi = formApi;
                                return (
                                    <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                                        <div className="card card-body bg-light">
                                            <h4>Please enter your new password</h4>
                                            <hr />
                                            <h5>
                                                <label htmlFor="password">Password</label>
                                            </h5>
                                            <Text field="password" id="password" className="form-control" type="password" />
                                            <h5>
                                                <label htmlFor="confirmPassword">Confirm Password</label>
                                            </h5>
                                            <Text field="confirmPassword" id="confirmPassword" className="form-control" type="password" />
                                        </div>
                                        <div>
                                            <br />
                                            {this.renderSaveButton()}
                                        </div>
                                    </form>
                                )
                            }}
                        </Form>
                    </div>
                    <div className="col-2"></div>
                    <div>
                    </div>
                </div>
                );
        }
    }

    render() {
        return <div>
            {this.renderMessage()}
            {this.renderGenerateTokenForm()}
            {this.renderPasswordResetForm()}
        </div>;
        
    }
}